// src/services/apiClient.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Injecte automatiquement le token sur chaque requête (si présent)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Log global des erreurs API
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('❌ API error:', error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient;